import { Link } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import animation from "../../../../Animation/Web.json";

import { useGSAP } from "@gsap/react";
import { useTranslation } from "react-i18next";
import { Menu } from "../../../../Context/MenuOpen/MenuContext";
import Lottie from "react-lottie";

gsap.registerPlugin(ScrollTrigger);

const AboutWebSolution = () => {
  const { t , i18n} = useTranslation()
  const contentRef = useRef(null);
  const lottieContainerRef = useRef(null);
  const menu = useContext(Menu);
  const isOpen = menu.isOpen;
  const [playLottie, setPlayLottie] = useState(false);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const imgRef = useRef(null);
  useGSAP(() => {
    gsap.from(contentRef.current, {
      scrollTrigger: {
        trigger: contentRef.current,
        start: "top 80%",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
      y: 50,
      duration: 1,
      ease: "power3.out",
    });
    gsap.from(imgRef.current, {
      opacity: 0,
      x: 80,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: imgRef.current,
        start: "top 90%",
        toggleActions: "play none none reverse",
      },
    });
    ScrollTrigger.create({
      trigger: lottieContainerRef.current,
      start: "top 80%",
      toggleActions: "play reverse play reverse",
      onEnter: () => setPlayLottie(true),
    });
  });

  return (
    <div className="StartProject px-[7vw] py-7 !flex-row">
      <div className="content" ref={contentRef}>
        <p className="py-3 fz-[1.1rem]">{t("WEB DEVELOPMENT")}</p>
        <h3 className=" md:max-w-[40vw]">
          {t("WHY CREATIVE BRANDS USED WEB DEVELOPMENT?")}
        </h3>
        <p>
          {t("website is more than just an online presence — it’s the core of your brand’s digital identity. Creative brands invest in web development to:")}
          <ul className="list-disc ml-5">
            <li className="mt-4">{t("Stand Out Visually – A unique, well-designed website reflects your brand’s personality and captures attention.")} </li>
            <li className="mt-4">{t("Deliver Seamless Experiences – Smooth navigation, responsive design, and fast performance keep visitors engaged.")}  </li>
            <li className="mt-4">{t("Build Trust & Credibility – A professional website gives customers confidence in your brand.")}  </li>
            <li className="mt-4">{t("Reach & Convert More Customers – Optimized websites boost visibility, improve SEO rankings, and drive higher conversions.")} </li>
            <li className="mt-4">{t("Scale with Growth – From landing pages to full platforms, custom development adapts as your business expands.")} </li>
          </ul>
            <span className="text-red-600 ">{t("Or")}</span> <br />
            {t("Creative brands use web development to stand out, build trust, and grow online. A powerful website isn’t just a presence — it’s the heart of your brand’s digital identity, designed to engage, convert, and scale with your vision.")}
        </p>
        <Link className="btn-hover">
          <span>{t("What’s include")}</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 2048 2048"
            >
              <path
                fill="currentColor"
                d="M1024 1024h768v896H128V256h896zM256 384v640h640V384zm640 1408v-640H256v640zm768 0v-640h-640v640zM1280 0h768v768h-768zm640 640V128h-512v512z"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div ref={lottieContainerRef} className="img md:!h-[360px]">
      {playLottie || isOpen ? (
          <Lottie
            options={defaultOptions}
            className="custom-lottie"
            isClickToPauseDisabled={true}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default AboutWebSolution;
